<div class='poam-component' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">{{ project?.name }} Gap Grid</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
      <button type="button"
              [routerLink]="['/projects', 'project', projectId]"
              pButton
              class="risksponge-button" icon="pi pi-arrow-left"></button>
      <button type="button"
              (click)="addActionPlan()"
              pButton
              class="risksponge-button" icon="pi pi-plus"></button>
    </div>
  </div>

  <p-table [value]="actionPlans"
           #poamTable
           [rows]="100"
           [reorderableColumns]="true"
           [paginator]="true"
           [pageLinks]="3"
           sortField="currentYearSequence"
           sortOrder="descending"
           [rowsPerPageOptions]="[10, 20, 50, 100]"
           [resizableColumns]="true"
           [metaKeySelection]="false"
           exportFilename="POAM"
           [columns]="cols"
           dataKey="actionPlanId"
          >

    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix flex flex-row justify-content-end">
        <button type="button"
                pButton
                class="risksponge-button"
                icon="pi pi-file-excel"
                iconPos="left"
                mwlConfirmationPopover
                [popoverTitle]=this.constants.WARNING_CUI_TITLE
                [popoverMessage]=this.constants.WARNING_CUI_MESSAGE
                popoverClass="confirmation-popover-hide-popover-arrow"
                [hideCancelButton]="true"
                placement="left"
                appendToBody="true"
                (confirm)="poamTable.exportCSV()"
                confirmText={{this.constants.LBL_I_UNDERSTAND}}>

        </button>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
        <th style="width: 3rem"></th>
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" pResizableColumn
            [ngStyle]="{'width': col.width || 'auto'}">
          {{ col.header }}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols" [ngSwitch]="col.field">
          <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                 (input)="poamTable.filter($event.target['value'], col.field, 'contains')">
          <span *ngSwitchCase="'dueDate'"></span>
        </th>

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
      <tr>
        <ng-container>
          <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="item"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td>
          <td *ngFor="let col of cols">
            <div [ngSwitch]="col.field">
              <div style="white-space: pre-line;text-align: left;" *ngSwitchCase="'loe'">{{ lowMediumHigh[item[col.field]] }}</div>
              <div style="white-space: pre-line;text-align: left;" *ngSwitchCase="'createdDate'">{{ item[col.field] | date : 'shortDate' }}</div>
              <div style="white-space: pre-line;text-align: left;" *ngSwitchCase="'dueDate'">{{ item[col.field] | date : 'shortDate' }}</div>
              <div style="white-space: pre-line;text-align: left;" *ngSwitchDefault>{{ item[col.field] }}</div>
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-item>
      <tr>
        <td [formGroup]="item.form" colspan="11">
          <div style="display: flex; gap: 20px; margin-top: 10px;">
            <div>
              <span style="cursor: pointer; text-decoration: underline;" (click)="selectProjectControlItem(item)" *ngIf="!item.complianceAreaControlId">Select Control Item</span>
              <span style="cursor: pointer; text-decoration: underline;" (click)="selectProjectControlItem(item)" *ngIf="item.complianceAreaControlId">{{item.complianceAreaControlId}}</span>
            </div>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Topic</mat-label>
              <mat-select formControlName="topic">
                <mat-option *ngFor="let topic of topics" [value]="topic">{{topic}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Name</mat-label>
              <input matInput type="text" name="name" formControlName="name"
                     required>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Risk Level</mat-label>
              <mat-select formControlName="riskLevel">
                <mat-option [value]="'High'">High</mat-option>
                <mat-option [value]="'Medium'">Medium</mat-option>
                <mat-option [value]="'Low'">Low</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Source</mat-label>
              <mat-select formControlName="source">
                <mat-option [value]="'Manually Created'">Manually Created</mat-option>
                <mat-option [value]="'Validation Finding'">Validation Finding</mat-option>
                <mat-option [value]="'POAM API'">POAM API</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>System</mat-label>
              <input matInput type="text" name="system" formControlName="system"
                     required>
            </mat-form-field>
          </div>
          <div style="display: flex; gap: 20px;">
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Description</mat-label>
              <input matInput type="text" name="weaknessDescription"
                     formControlName="weaknessDescription"
                     required>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Affected Systems</mat-label>
              <input matInput type="text" name="affectedSystems" formControlName="affectedSystems"
                     required>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Current Status</mat-label>
              <mat-select formControlName="currentStatus"
                          required>
                <mat-option [value]="0">Not Started</mat-option>
                <mat-option [value]="1">In-Progress</mat-option>
                <mat-option [value]="2">Resolved</mat-option>
                <mat-option [value]="3">Awaiting Review</mat-option>
                <mat-option [value]="4">Reviewed - Not POAM</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <div style="display: flex; gap: 20px;width:100%">
            <mat-form-field class="input-section" style="width:25%">
              <mat-label>Date of Identification</mat-label>
              <input matInput [matDatepicker]="identificationDatePicker" name="identificationDate"
                     formControlName="identificationDate"
                     required>
              <mat-datepicker-toggle matSuffix [for]="identificationDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #identificationDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:25%">
              <mat-label>How Identified</mat-label>
              <input matInput type="text" name="howIdentified" formControlName="howIdentified"
                     required>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:25%">
              <mat-label>Requirements or Guidance</mat-label>
              <mat-select formControlName="requirementOrGuidance">
                <mat-option [value]="'Requirement'">Requirement</mat-option>
                <mat-option [value]="'Guidance'">Guidance</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div style="display: flex; gap: 20px; ">
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>LoE</mat-label>
              <mat-select formControlName="loe">
                <mat-option [value]="2">High</mat-option>
                <mat-option [value]="1">Medium</mat-option>
                <mat-option [value]="0">Low</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Responsible Party</mat-label>
              <input matInput name="responsibleParty" formControlName="responsibleParty">
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Remediation Plans, Actions and Milestones</mat-label>
              <input matInput type="text" name="remediationPlansActionsMilestones"
                     formControlName="remediationPlansActionsMilestones">
            </mat-form-field>

          </div>

          <div style="display: flex; gap: 20px;">
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Target Completion Date</mat-label>
              <input matInput [matDatepicker]="scheduledCompletionDatePicker"
                     name="scheduledCompletionDate" formControlName="scheduledCompletionDate">

              <mat-datepicker-toggle matSuffix
                                     [for]="scheduledCompletionDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #scheduledCompletionDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Actual Completion Date</mat-label>
              <input matInput [matDatepicker]="actualCompletionDatePicker" name="actualCompletionDate"
                     formControlName="actualCompletionDate">

              <mat-datepicker-toggle matSuffix
                                     [for]="actualCompletionDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #actualCompletionDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="input-section" style="width:100%">
              <mat-label>Changes to Remediation Plans, Actions, and Milestones (if
                applicable)</mat-label>
              <input matInput type="text" name="changesToRemediationPlansActionsMilestones"
                     formControlName="changesToRemediationPlansActionsMilestones">
            </mat-form-field>
          </div>

          <div style="display: flex; gap: 20px;">
            <mat-form-field class="textarea-section" style="width: 100%;">
              <mat-label>Comments</mat-label>
              <textarea matInput cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" type="text"
                        name="comments" formControlName="comments">
                        </textarea>
            </mat-form-field>

          </div>

          <div style="display: grid; gap: 20px;">
            <mat-slide-toggle class="example-margin" name="typeBool" formControlName="typeBool">
              Visible in POA&M
            </mat-slide-toggle>
          </div>
          <div>
            <button mat-raised-button
                    style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
                    class="button" (click)="save(item)">
              Save
            </button>
            @if (item.form.value.signedName) {
              Signed by {{item.form.value.signedName}} on {{item.form.value.signedDate | date : 'shortDate'}}
            }
            <i class="pi pi-credit-card cursor-pointer" (click)="sign(item)"></i>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
